import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';

@Component({
    selector: 'app-indagine-note',
    templateUrl: './indagine-note.component.html',
    imports: [CommonModule,ReactiveFormsModule, InputTextModule, TextareaModule],
    standalone: true
})
export class IndagineNoteComponent {
    @Input() form!: FormGroup;
}
